<script setup lang="ts">
import { nextTick, ref, watch } from 'vue';
import { type ClinicalRecordItemType } from '@/api/clinical-record-history';
import ClinicalRecordHistoryDialog from './clinical-record-history-dialog.vue';

// "Editado" mark and "Ver historial" button of a registro clínico, placed
// next to its date. The dialog mounts on first open, so a long list adds no
// dialog or query per row.
const props = withDefaults(defineProps<{
  itemType: ClinicalRecordItemType;
  itemId: number;
  // What the registro is, for the button name and the dialog
  // ("Registro escrito · 10/03 14:00").
  label: string;
  // The registro changed after it was recorded (serializers' `edited`).
  edited?: boolean;
}>(), { edited: false });

const open = ref(false);
const mounted = ref(false);
const button = ref<{ $el: HTMLElement } | null>(null);

function show() {
  mounted.value = true;
  open.value = true;
}

// The dialog opens without an activator, so focus goes back to the button by hand.
watch(open, async (isOpen) => {
  if (isOpen) return;
  await nextTick();
  button.value?.$el.focus();
});
</script>
<template>
  <span class="d-inline-flex align-center ga-1 ms-1">
    <v-chip
      v-if="props.edited"
      size="x-small"
      variant="tonal"
      color="grey-darken-3"
      label
    >
      Editado
    </v-chip>
    <v-btn
      ref="button"
      icon
      size="small"
      variant="text"
      density="comfortable"
      :aria-label="`Ver historial (${props.label})`"
      @click.stop="show"
    >
      <v-icon
        icon="mdi-history"
        size="small"
      />
      <v-tooltip
        activator="parent"
        location="top"
      >
        Ver historial
      </v-tooltip>
    </v-btn>
    <clinical-record-history-dialog
      v-if="mounted"
      v-model="open"
      :item-type="props.itemType"
      :item-id="props.itemId"
      :label="props.label"
    />
  </span>
</template>
